module.exports = __webpack_public_path__ + "img/logo_cleverdocs_blanc.cc42ca1b.png";